import { loaderService } from 'src/services/loaderService';
import { apileads } from '../enviroment/apileads';

/** funciones victory mas */
const getScores = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/score');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

const putScore = async (params) => {
  loaderService.show();
  const response = await apileads.put('/v1/score', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

const postProcess = async (params) => {
  loaderService.show();
  const response = await apileads.post('/v1/scoreprocess', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

/** funciones victory mas */

/** funciones Tvs */
const getScoresTvs = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/score-tvs');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

const putScoreTvs = async (params) => {
  loaderService.show();
  const response = await apileads.put('/v1/score-tvs', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

const postProcessTvs = async (params) => {
  loaderService.show();
  const response = await apileads.post('/v1/scoreprocess-tvs', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error);
  }
};

/** funciones Tvs */

export { getScores, putScore, postProcess, getScoresTvs, putScoreTvs, postProcessTvs };
